export const formatMinutes = (minutes: number | null | undefined) => {
	if (minutes == null) return "";
	const h = Math.floor(minutes / 60);
	const m = minutes % 60;
	return h > 0 ? `${h}h ${m.toString().padStart(2, "0")}m` : `${m}m`;
};
